import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import * as api from '@services/api/affiliate'
import { Affiliate } from 'AppTypes'

const initialState = {
  affiliateList: [] as Affiliate[],
  selectedAffiliate: {} as Affiliate,
  editMode: 'edit' as 'edit' | 'create',
  keyword: '',
  status: -1 as -1 | 0 | 1,
  pageIndex: 1,
  pageSize: 10,
  totalRecords: 0,
  totalPage: 0
}

export const fetchAffiliateList = createAsyncThunk(
  'affiliate/fetchAffiliateList',
  async (params: any) => {
    const response = await api.fetchAffiliateList(params)
    return response
  }
)

export const fetchAffiliateById = createAsyncThunk(
  'affiliate/fetchAffiliateById',
  async (id: string) => {
    const response = await api.fetchAffiliateById(id)
    return response.data
  }
)

export const addAffiliate = createAsyncThunk(
  'affiliate/addAffiliate',
  async (data: any) => {
    const response = await api.addAffiliate(data)
    return response
  }
)

export const updateAffiliate = createAsyncThunk(
  'affiliate/updateAffiliate',
  async (data: any) => {
    const response = await api.updateAffiliate(data)
    return response
  }
)

export const deleteAffiliate = createAsyncThunk(
  'affiliate/deleteAffiliate',
  async (id: string) => {
    const response = await api.deleteAffiliate(id)
    return response
  }
)

const affiliateSlice = createSlice({
  name: 'affiliate',
  initialState,
  reducers: {
    changePage: (state, action) => {
      state.pageIndex = action.payload
    },
    selectAffiliate: (state, action) => {
      state.selectedAffiliate = action.payload
      state.editMode = 'edit'
    },
    changeFilter: (state, action) => {
      state.keyword = action.payload.keyword
      state.status = action.payload.status
    },
    newAffiliate: state => {
      state.editMode = 'create'
      state.selectedAffiliate = {
        companyName: '',
        province: '愛知県',
        managerName: '',
        phoneNumber: '',
        email: '',
        couponCode: '',
        registerDate: new Date(),
        status: 0
      } as Affiliate
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchAffiliateList.fulfilled, (state, action) => {
      state.affiliateList = action.payload.data
      state.pageIndex = action.payload.pageIndex
      state.pageSize = action.payload.pageSize
      state.totalRecords = action.payload.totalRecords
      state.totalPage = Math.ceil(action.payload.totalRecords / action.payload.pageSize)
    })
    builder.addCase(fetchAffiliateById.fulfilled, (state, action) => {
      state.selectedAffiliate = action.payload
    })
  }
})

export const {
  changePage,
  selectAffiliate,
  changeFilter,
  newAffiliate
} = affiliateSlice.actions

export default affiliateSlice.reducer
